import { Empresa } from './empresa';
export class Usuario {
  id: number;
  nome: string;
  dataNascimento: string;
  email: string;
  cpf: string;
  senha: string;
  etapa: number;
  telefone1: string;
  telefone2: string;
  perfil: string;
  aprovado: boolean;
  rejeitado: boolean;
  empresaPadrao: Empresa;
  ebarn: boolean;
  verificationMail: string;
  avatar: string;
  tokenFb: string;
  tokenAplicacao: string;
  urlInvite: string;
  perfilUsuario?: string;
  atendente: boolean;

  isProdutor(): boolean {
    return this.perfil === 'PRODUTOR' || this.perfil === 'P';
  }

  isFornecedor(): boolean {
    return this.perfil === 'FORNECEDOR' || this.perfil === 'F';
  }

  isIndustria(): boolean {
    return this.perfil === 'INDUSTRIA';
  }
}
